import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Regulations from "./views/Regulations.vue";
import Competencies from "./views/Competencies.vue";
import Competence from "./views/Competence.vue";
import Archive from "./views/Archive.vue";
import TrainingCenters from "./views/TrainingCenters.vue";
import Search from "./views/Search.vue";
import Managers from "./views/Managers.vue";
import Faq from "./views/Faq.vue";
import BestPractice from "./views/BestPractices.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/regulations",
      name: "regulations",
      component: Regulations,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Разделы" }
        ]
      }
    },
    {
      path: "/competencies",
      name: "competencies",
      component: Competencies,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Разделы" }
        ]
      }
    },
    {
      path: "/competencies/:competenceId/categories/:categoryId",
      name: "competence",
      component: Competence,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Разделы", link: "/competencies" },
          { name: "Раздел" }
        ]
      }
    },
    {
      path: "/archive",
      name: "archive",
      component: Archive,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Архив требований" }
        ]
      }
    },
    {
      path: "/training-centers",
      name: "training-centers",
      component: TrainingCenters,
      meta: {
        breadcrumbs: [{ name: "Главная", link: "/" }, { name: "Список ЦПДЭ" }]
      }
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Результаты поиска" }
        ]
      }
    },
    {
      path: "/managers",
      name: "managers",
      component: Managers,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Менеджеры компетенций" }
        ]
      }
    },
    {
      path: "/best-practices",
      name: "bestpractices",
      component: BestPractice,
      meta: {
        breadcrumbs: [
          { name: "Главная", link: "/" },
          { name: "Лучшие практики" }
        ]
      }
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq,
      meta: {
        breadcrumbs: [{ name: "Главная", link: "/" }, { name: "FAQ" }]
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
